<template>
    <div>
        <section class="py-3 py-md-3">
            <div class="container py-2">
                <div class="breadcrumbs-retos ">
                    <a href="/home-bat">
                        <img src="/img/icons/homeBread.svg" alt="" />
                    </a>
                    <a class="link cursor-pointer" href="#" @click="returnView()">A la practica </a>
                    <a class="link cursor-pointer" href="#" @click="returnView()">Aprendizaje /</a>
                    <span class="color-active-miga" v-if="learning !== null"><strong>{{ learning.title }}</strong></span>
                </div>
                <a href="#" @click="returnView()"><img src="/img/icons/regresar.svg" alt="icon"></a>
            </div>
        </section>

        <div class="container pb-5 datos text-bat">
            <div v-if="learning !== null">
                <h2 class="titleModulo" v-if="learning">{{ learning.title }} <span v-if="status === 'completed'" class="text-success"><i class="fa-solid fa-circle-check"></i> Completado</span></h2>
                <p>
                    {{ learning.description }}
                </p>
            </div>
            <div class="row">
                <div class="col-12 col-md-1 avance reto-mobile pt-3">
                    <ul class="nav nav-pills mb-3 content-pasos d-flex justify-content-between justify-content-md-center pb-4 pb-md-0 mb-md-0">
                        <li v-for="content in contents" role="presentation">
                            <div :class="step === content.step ? 'progreso' : step > content.step ? 'active' : ''" id="pills-home-tab">
                                <div class="paso text-center">
                                    <div class="icon">
                                    </div>
                                    <p>
                                        Lección {{ content.step }}
                                    </p>
                                    <!-- <p class="sub">
                                        {{ content.title }}
                                    </p> -->
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div v-if="current_content !== null" class="col-12 col-md-11">
                    <p class="title-aprendizaje">Lección {{ step }}: {{ current_content.title }}</p>
                    <div class="bannerModule pb-5">
                        <iframe v-if="current_content.video"
                            :src="current_content.video+'&color=410978&autoplay=1&title=0&byline=0&portrait=0&autopause=0&muted=1&controls=1'"
                            style="width:100%;height:600px;" frameborder="0"
                            allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                        <img v-else-if="current_content.image" :src="current_content.image" :alt="current_content.title" class="w-100">
                        <img v-else src="https://picsum.photos/id/237/970/240" :alt="current_content.title" class="w-100">
                    </div>
                    <div class="content-two-cols mb-3">
                        <article class="content" v-html="current_content.content"></article>
                    </div>
                    <!-- <div class="row">
                        <div class="col-6 d-flex justify-content-center justify-content-md-start">
                            <div v-if="step > 1" @click="previewsStep" class="button button-underline">Anterior</div>
                            <div v-else class="button button-underline disabled">Anterior</div>
                        </div>
                        <div class="col-6 d-flex justify-content-end">
                            <div v-if="step < contents.length" @click="nextStep" class="button button-blue px-5">Siguiente</div>
                            <div v-else @click="finishLearning" class="button button-blue px-3">Finalizar</div>
                        </div>
                    </div> -->


                    <div class="row">
                        <div class="col-6 d-flex justify-content-center justify-content-md-start">
                                <div v-if="step === 1" @click="cancel" class="mt-2 text-more cursor-pointer text-decoration-underline text-center">Cancelar</div>
                                <div v-else-if="step > 1" @click="previewsStep" class="button button-underline">Anterior</div>
                        </div>

                        <div class="col-6 d-flex justify-content-end">
                            <div v-if="step < contents.length" @click="nextStep" class="button button-blue px-5">Siguiente</div>
                            <div v-else @click="finishLearning" class="button button-blue px-3">Lección aprendida</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <el-dialog
            :visible.sync="modal_finish"
            :width="$mq === 'sm' ? '90%' : '40%'"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false">
            <div class="align-items-center text-center flex-column justify-content-center" v-if="learning">
                <img src="/img-version2/modal/tick-circle.svg" alt="image 8">
                <h4>¡Felicitaciones!</h4>
                <p>Completaste todas las lecciones del módulo <br> {{ learning.title }}</p>
                <div v-if="learning.has_quiz">
                    <div v-if="quiz_presented">
                        <p>Has completado el contenido de este módulo de aprendizaje y ya presentaste el quiz correspondiente anteriormente.</p>
                        <a href="#" @click="returnView()" class="px-5 text-decoration-underline text-title-bat text-indigo">Regresar a los modulos</a> <a :href="`/learning/${learning.id}/quiz/feedback`" class="button button-blue px-5">Ir a la retroalimentación</a>
                    </div>
                    <div v-else-if="learning.required_quiz">
                        <p v-if="learning.points_to_win > 0">Debes presentar un quiz sobre el módulo para reforzar los conocimientos aprendidos y tener la oportunidad de ganar {{ learning.points_to_win }} puntos.</p>
                        <p v-else>Debes contestar un quiz sobre el módulo para reforzar los conocimientos aprendidos</p>
                        <a :href="`/learning/${learning.id}/quiz`" class="button button-blue px-5">Ir al quiz</a>
                    </div>
                    <div v-else>
                        <p v-if="learning.points_to_win > 0">Puedes contestar un quiz sobre el módulo para reforzar los conocimientos aprendidos y obtener <strong>{{ learning.points_to_win }} puntos</strong> si obtienes un <strong>{{ learning.percentage_to_win }}% de respuestas correctas</strong></p>
                        <p v-else>Puedes contestar un quiz sobre el módulo para reforzar los conocimientos aprendidos</p>
                        <a href="#" @click="returnView()" class="px-5 text-decoration-underline text-title-bat text-indigo">Regresar a los módulos</a> <a :href="`/learning/${learning.id}/quiz`" class="button button-blue px-5">Ir al quiz</a>
                    </div>
                </div>
                <div v-else>
                    <a href="#" @click="returnView()" class="button button-blue px-5">Aceptar</a>
                </div>
            </div>
        </el-dialog> -->

        <el-dialog
        :visible.sync="modal_finish"
        :width="$mq === 'sm' ? '90%' : '40%'"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        >
            <div class="align-items-center text-center flex-column justify-content-center" v-if="learning">

                <!-- Diseño SI tiene quiz -->
                <template v-if="learning.has_quiz">
                    <img src="/img-version2/modal/like.svg" alt="like icon">
                    <h4>Siguiente paso: Quiz.</h4>
                </template>

                <!-- Diseño si NO tiene quiz -->
                <template v-else>
                    <img src="/img-version2/modal/tick-circle.svg" alt="tick icon">
                    <h4>¡Felicitaciones!</h4>
                    <p>Completaste todas las lecciones del módulo <br> {{ learning.title }}</p>
                </template>

                <!-- Contenido cuando tiene quiz -->
                <div v-if="learning.has_quiz">
                    <div v-if="quiz_presented">
                        <p>Has completado el contenido de este módulo de aprendizaje y ya presentaste el quiz correspondiente anteriormente.</p>

                        <a :href="`/learning/${learning.id}/quiz/feedback`" class="button button-blue px-5">
                            Ir a la retroalimentación
                        </a>

                        <a href="#" @click="returnView()" class="px-5 text-decoration-underline text-title-bat text-indigo">
                            Regresar a los módulos
                        </a>
                    </div>

                    <div v-else-if="learning.required_quiz">
                        <p v-if="learning.points_to_win > 0 && isLinked">
                            Debes realizar un quiz sobre el módulo para reforzar los conocimientos adquiridos y tener la oportunidad de ganar {{ learning.points_to_win }} puntos.
                        </p>
                        <p v-else>Debes contestar un quiz sobre el módulo para reforzar los conocimientos aprendidos</p>
                        <a :href="`/learning/${learning.id}/quiz`" class="button button-blue px-5">
                            Comenzar quiz
                        </a>
                        <div class="mt-4 px-5 w-100 text-more cursor-pointer text-decoration-underline text-center" @click.prevent="cancelLesson">
                            Quizás más tarde
                        </div>
                    </div>

                    <div v-else>
                        <p v-if="learning.points_to_win > 0">
                            Puedes contestar un quiz sobre el módulo para reforzar los conocimientos aprendidos y obtener {{ learning.points_to_win }} puntos si obtienes un {{ learning.percentage_to_win }}% de respuestas correctas
                        </p>
                        <p v-else>Puedes contestar un quiz sobre el módulo para reforzar los conocimientos aprendidos</p>

                        <a :href="`/learning/${learning.id}/quiz`" class="button button-blue px-5">
                            Comenzar quiz
                        </a>
                        <div class="mt-4">
                            <a href="#" @click="returnView()" class="px-5 text-decoration-underline text-title-bat text-indigo">
                                Regresar a los módulos
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Contenido si NO tiene quiz -->
                <div v-else>
                    <a href="#" @click="returnView()" class="button button-blue px-5">
                        Aceptar
                    </a>
                </div>

            </div>
        </el-dialog>

        <el-dialog
            :visible.sync="modal_cancel"
            width="320px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="true"
            class="cancel-popup"
        >
            <div class="text-center p-3 d-flex flex-column align-items-center justify-content-center">

                <div class="circle-icon mb-3">
                <img src="/img-version2/modal/close-circle.svg" alt="Cancelar" width="60" height="60">
                </div>

                <h5 class="fw-bold mb-2">¿Estás seguro de que quieres cancelar esta lección?</h5>
                <p class="text-secondary mb-4">Si la cancelas ahora, perderás tu progreso.</p>

                <a type="primary" class="button button-blue px-5" @click="modal_cancel = false">
                    Seguir con la lección
                </a>

                <a href="#" class="mt-4 px-5 w-100 text-more cursor-pointer text-decoration-underline text-center" @click.prevent="cancelLesson">
                    Sí, cancelar
                </a>
            </div>
        </el-dialog>
    </div>
</template>

<script>

import { EventBus } from './../../app';
export default {
    props: {
        learning: {
            default: null,
        },
        contents: {
            default: null,
        },
        url_storage: {
            default: null,
        },
        status: {
            default: 'pending',
        },
        questions_count: {
            default: 0,
        }
    },
    data() {
        return {
            loading: 0,
            step: 1,
            current_content: null,
            modal_finish: false,
            first_time: true,
            quiz_presented: false,
            modal_cancel: false,

            isLinked: false,
        }
    },
    mounted () {
        if(this.contents.length > 0){
            this.current_content = this.contents[0]
        }

        this.validateLinkingDate();
    },
    methods: {
        nextStep() {
            this.current_content = this.contents[this.step]
            this.step++
            window.scrollTo({ top: 100, left: 100, behavior: 'smooth' });
        },
        previewsStep() {
            this.step--
            this.current_content = this.contents[this.step-1]
            window.scrollTo({ top: 100, left: 100, behavior: 'smooth' });
        },
        finishLearning(){
            this.loading++
            axios.post(`/learning/${this.learning.id}/finish`).then(
                ({data}) => {
                    if(data.quiz_presented){
                        this.quiz_presented = true
                    }
                    this.modal_finish = true
                    this.loading--
                })
        },
        returnView(){
            EventBus.$emit('refresh-points', true);
            if (window.history.length > 3) {
                // history.back()
                window.open(`/retos?page=1&option=learning`, "_self", "noopener,noreferrer")
            } else {
                window.open(`/retos?page=1&option=learning`, "_self", "noopener,noreferrer")
            }
        },
        cancel() {
            this.modal_cancel = true;
        },
        cancelLesson() {
            window.location.href = '/retos';
        },
        validateLinkingDate(){
            axios
                .get(`/validate-linking-date`)
                .then(({ data }) => {
                    this.isLinked = data.is_linked;
                })
                .catch(error => {
                    console.error('Error al obtener el estado de vinculación al punto de venta:', error);
                    this.isLinked = false;
                });
        },
    },
}

setTimeout(() => {
    const iframe = document.querySelector('iframe')

    if (iframe) {
        const resizeIframeVideo = () => {
            let documentWidth = document.documentElement.clientWidth
            let newIframeHeight = 700

            switch (true) {
                case documentWidth >= 1200 && documentWidth < 1400:
                    newIframeHeight = 600
                    break;
                case documentWidth >= 990 && documentWidth < 1200:
                    newIframeHeight = 500
                    break;
                case documentWidth >= 768 && documentWidth < 990:
                    newIframeHeight = 400
                    break;
                case documentWidth >= 570 && documentWidth < 768:
                    newIframeHeight = 300
                    break;
                case documentWidth >= 320 && documentWidth < 570:
                    newIframeHeight = (documentWidth / 1.875)
                    break;
                case documentWidth < 320:
                    newIframeHeight = 170
                    break;
            }

            iframe.style.height = newIframeHeight + 'px'
        }

        resizeIframeVideo()

        window.addEventListener('resize', resizeIframeVideo)
    }
}, 0)
</script>
